module.exports = __webpack_public_path__ + "img/45.69e11cc6.png";